import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { SUPPORT_URL } from 'constants/URLs';
import { partnerUuidSelector } from 'helpers/selectors/selectors';

/**
 * Provides a handler for navigating to the support page.
 * If a partner UUID is present, navigates to the given internal path.
 * Otherwise opens the external support site in a new tab.
 *
 * @returns {Function} navigateToSupport - accepts a path string for internal navigation
 */
const useNavigateToSupport = () => {
    const navigate = useNavigate();
    const partnerUuid = useSelector(partnerUuidSelector);

    return (path) => {
        if (!partnerUuid) {
            window.open(SUPPORT_URL, '_blank');
        } else {
            navigate(path);
        }
    };
};

export default useNavigateToSupport;
